// extracted by mini-css-extract-plugin
export default {"iconlinks":"IconLinks_iconlinks__LxAbH","iconlinks__item":"IconLinks_iconlinks__item__IaHlr","iconlinks__icon":"IconLinks_iconlinks__icon__5cgG9"};